import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function usePortfolioHealth() {
  const { user } = useAuth();

  const healthQuery = useQuery({
    queryKey: ['portfolio-health', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('portfolio_health')
        .select('*')
        .eq('user_id', user!.id)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
    enabled: !!user?.id,
    refetchInterval: 60000,
  });

  const snapshotsQuery = useQuery({
    queryKey: ['portfolio-snapshots', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('portfolio_snapshots')
        .select('total_equity, total_cash, total_positions_value, allocation_by_class, snapshot_at')
        .eq('user_id', user!.id)
        .order('snapshot_at', { ascending: true })
        .limit(2000);
      if (error) throw error;
      return data ?? [];
    },
    enabled: !!user?.id,
    refetchInterval: 300000,
  });

  return {
    health: healthQuery.data ?? null,
    snapshots: snapshotsQuery.data ?? [],
    isLoading: healthQuery.isLoading || snapshotsQuery.isLoading,
    error: healthQuery.error || snapshotsQuery.error,
  };
}
